import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import EditDetails from "../../components/Forms/EditDetails";
import EditNews from "../../components/Forms/EditNews";
import EditKuldevi from "../../components/Forms/EditKuldevi";
import EditRasam from "../../components/Forms/EditRasam";
import EditBloodBank from "../../components/Forms/EditBloodBank";
import EditJobs from "../../components/Forms/EditJobs";
import EditGallery from "../../components/Forms/EditGallery";
import EditCategoryGallery from "../../components/Forms/EditCategoryGallery";


class FormEditCategoryGallery extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Validation"
              Breadcrumb={[
                { name: "Form", navigate: "" },
                { name: "Validation", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              {/* <BasicValidation /> */}
              <EditCategoryGallery/>
            </div>
            <div className="row clearfix">
              {/* <AdvancedValidation /> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({});

export default connect(mapStateToProps, {})(FormEditCategoryGallery);
